<template lang="pug">

  div

    //-
      -
      - Modal CRIAR ESCALA
      -
      -

    v-dialog(v-model="isVisible" max-width="500px" width="100%" persistent)

      .dialogHeader

        .dialogHeaderTitle
          | Nova escala

        .dialogHeaderClose
          .dialogCloseButton.mdi.mdi-close(@click="close(false)")

      .dialogBody

        .dialogBodyContent

          .createTurnField.createTurnField--first
            label.csLabel
              span(v-html="'Nome da escala'")
            .csFields
              input(v-model="scaleName" :disabled="loading" class="sosInput" maxlength="64" placeholder="Entre 1 e 64 caracteres")

          .fieldError(v-if="error.name")
            | Digite um nome de até 64 caracteres.

          div(v-if="presetLocations")

            .createTurnField
              sos-select(label="Local" :items="groupLocations" @sosSelectChanged="selectedScaleLocation" :default="scaleLocation.id" :disabled="loading")

            span.fieldNote
              b Nota:
              |  O grupo tem locais pré-definidos. Clique no campo acima para escolher um local.

          div(v-else)

            .createTurnField
              label.csLabel
                span(v-html="'Local'")
              .csFields
                input(v-model="scaleLocation.name" :disabled="loading" class="sosInput" maxlength="64" placeholder="Deixe vazio ou informe um local entre 3 e 64 caracteres")

            span.fieldNote
              b Nota:
              |  O grupo não tem locais pré-definidos. Você pode informar um local personalizado.

          .fieldError(v-if="error.local")
            | Limpe o nome do local ou digite um nome de 3 a 64 caracteres.

          .createTurnField.createTurnField--last
            label.csLabel
              span(v-html="'Valor por hora'")
            .csFields
              app-money-light(:value="scaleValue" :blur-event="onBlurScaleValue" :disabled="loading")

          .createTurnField
            label.csLabel
              span(v-html="'Número máximo de plantões por usuário'")
            .csFields
              input(v-model="scaleMaxShifts" :disabled="loading" class="sosInput" maxlength="4" placeholder="Deixe vazio ou informe uma quantidade de 1 a 9999" @input="onScaleMaxShiftsChange(scaleMaxShifts)")

          .fieldError(v-if="error.maxShifts")
            | Limpe o campo ou digite uma quantidade menor que 9999.

          .dialogSubtitle
            | PREFERÊNCIAS

          .preLocais
            .locaisMsg
              | Começar semana na Segunda-feira:
            sos-switch(:value="startOnMonday" @click="onChangeCalendarMode" :disabled="loading")

          .preLocais
            .locaisMsg
              | Cor dos plantões assumidos:
            .sosShiftColorTag(@click="openOwnedShiftsColorPicker" :style="{ 'background-color': colorShiftsOwned }")

          .fieldError(v-if="error.ownedShiftsColor")
            | Escolha uma cor para os plantões assumidos.
          .fieldError.mb-4(v-if="error.ownedShiftWhite")
            | A cor é muito clara! Escolha um tom mais escuro.

          .preLocais
            .locaisMsg
              | Cor dos plantões livres:
            .sosShiftColorTag(@click="openAvailableShiftsColorPicker" :style="{ 'background-color': colorShiftsAvailable }")

          .fieldError.mb-4(v-if="error.availableShiftsColor")
            | Escolha uma cor para os plantões disponiveis.
          .fieldError.mb-4(v-if="error.availableShiftWhite")
            | A cor é muito clara! Escolha um tom mais escuro.

          .fieldError.mb-4(v-if="error.sameShiftsColor && (!error.availableShiftWhite && !error.ownedShiftWhite)")
            | Escolha uma cor diferente para plantões disponíveis e assumidos.

          .text-right.mt-5
            sos-button(@buttonClick="close(false)" size="medium" buttonLabel="Fechar" buttonIcon="mdi-close" buttonIconSize="16" color="blue" :disabled="loading").mr-3
            sos-button(@buttonClick="createScale" size="medium" buttonLabel="Criar" buttonIcon="mdi-plus" buttonIconSize="16" color="success" :disabled="loading")

    //-
      -
      - Modal AVISO
      -
      -

    confirm-dialog(ref="cdConfirmModal" :title="cdParameters.title" :text="cdParameters.text" :buttonPosition="cdParameters.buttonPosition" :width="cdParameters.width" @close="cdAction")

    //-
      -
      - Modal SOS COLOR PICKER
      -
      -

    sos-color-picker(ref="dialogAvailableColorPicker" @close="onAvailableShiftsColorPickerClose")
    sos-color-picker(ref="dialogOwnedColorPicker" @close="onOwnedShiftsColorPickerClose")

</template>

<script>

  import { isLightColor } from '@/functions'
  import { validateLocationName } from '@/functions/groups'
  import { validateScaleName } from '@/functions/scales'

  import AppMoneyLight from '@/components/base/AppMoneyLight'
  import SosSelect from '@/components/SosSelect'
  import SosButton from '@/components/SosButton'
  import SosSwitch from '@/components/SosSwitch'
  import ConfirmDialog from '@/modals/ConfirmDialog'
  import SosColorPicker from '@/modals/SosColorPicker'

  import { apiCreateScale } from '@/services/firebase'

  import confirmDialogMixin from '@/mixins/cd.mixin.js'

  export default {
    name: 'ScaleCreate',

    components: {
      'app-money-light': AppMoneyLight,
      'sos-select': SosSelect,
      'sos-button': SosButton,
      'sos-switch': SosSwitch,
      'confirm-dialog': ConfirmDialog,
      'sos-color-picker': SosColorPicker,
    },

    mixins: [
      confirmDialogMixin,
    ],

    data () {
      return {
        isVisible: false,
        loading: false,

        presetLocations: false,
        groupLocations: [],

        error: {
          name: false,
          local: false,
          maxShifts: false,
          availableShiftsColor: false,
          ownedShiftsColor: false,
          sameShiftsColor: false,
          availableShiftWhite: false,
          ownedShiftWhite: false,
        },

        scaleName: '',
        scaleLocation: { id: '', name: '' },
        scaleMaxShifts: 0,
        scaleValue: 0,

        startOnMonday: false,

        colorShiftsAvailable: '#00cb72',
        colorShiftsOwned: '#2196f3',
      }
    },

    // created () {
    // },

    // mounted () {
    // },

    beforeDestroy () {
      this.clear()
    },

    // unmounted () {
    // },

    methods: {
      //
      // GESTÃO DO POPUP + DADOS
      //

      reset () {
        this.isVisible = false
        this.loading = false
        this.presetLocations = false
        this.groupLocations = []

        this.error = {
          name: false,
          local: false,
          maxShifts: false,
          availableShiftsColor: false,
          ownedShiftsColor: false,
          sameShiftsColor: false,
          availableShiftWhite: false,
          ownedShiftWhite: false,
        }

        this.scaleName = ''
        this.scaleLocation = { id: '', name: '' }
        this.scaleValue = 0
        this.scaleMaxShifts = 0
        this.startOnMonday = false
        this.colorShiftsAvailable = '#00cb72'
        this.colorShiftsOwned = '#2196f3'

        // cd.mixin.js
        this.cdParameters = { title: '', text: '', buttonPosition: 'right', width: 330 }
      },

      clear () {
        this.reset()

        delete this.isVisible
        delete this.loading
        delete this.presetLocations
        delete this.groupLocations
        delete this.error
        delete this.scaleName
        delete this.scaleLocation
        delete this.scaleValue
        delete this.scaleMaxShifts
        delete this.startOnMonday
        delete this.colorShiftsAvailable
        delete this.colorShiftsOwned

        // cd.mixin.js
        delete this.cdParameters
      },

      open (selectedGroup) {
        this.isVisible = true

        this.presetLocations = !!selectedGroup.fixLocais

        this.groupLocations = selectedGroup.groupLocations.length > 0 ? selectedGroup.groupLocations.map(groupLocation => ({
          key: 'scaleLocation_' + groupLocation.groupPlaceID,
          value: groupLocation.groupPlaceID,
          text: `${groupLocation.groupPlaceName}${groupLocation.isGroupLocationGeofenced ? ` <span class="scLocationStatus" data-active="true"> - Área: ${groupLocation.groupPlaceRadius} metros</span>` : ' <span class="scLocationStatus" data-active="false"> - Área: Desativada</span>'}`,
        })) : []
      },

      close (confirmed = false) {
        this.reset()
        this.$emit('close', confirmed)
      },

      //
      //
      //

      openAvailableShiftsColorPicker () {
        this.$refs.dialogAvailableColorPicker.open(this.colorShiftsAvailable)
      },

      openOwnedShiftsColorPicker () {
        this.$refs.dialogOwnedColorPicker.open(this.colorShiftsOwned)
      },

      onAvailableShiftsColorPickerClose (action) {
        if (!!action === false) return false

        this.colorShiftsAvailable = action
      },

      onOwnedShiftsColorPickerClose (action) {
        if (!!action === false) return false

        this.colorShiftsOwned = action
      },

      //
      // FIELD ERROR HANDLING
      //

      resetErrors () {
        this.error.name = false
        this.error.local = false
        this.error.maxShifts = false
        this.error.availableShiftsColor = false
        this.error.ownedShiftsColor = false
        this.error.sameShiftsColor = false
        this.error.availableShiftWhite = false
        this.error.ownedShiftWhite = false
      },

      getErrors () {
        return this.error
      },

      setError (error, status = true) {
        this.error[error] = status
      },

      //
      // CREATE SCALE
      //

      async createScale ()
      {
        //
        // SANITIZE/PREPARE SOME DATA
        //

        const scaleName = String(this.scaleName).trim()
        const scaleMaxShifts = Number(this.scaleMaxShifts)
        const colorShiftsAvailable = String(this.colorShiftsAvailable).toUpperCase()
        const colorShiftsOwned = String(this.colorShiftsOwned).toUpperCase()

        //
        // VALIDATE FIELDS
        //

        this.resetErrors()

        // VERIFICA SE O NOME DA ESCALA FOI PREENCHIDO CORRETAMENTE
        if (!validateScaleName(scaleName)) this.setError('name')

        // VERIFICA SE O LOCAL PERSONALIZADO FOI PREENCHIDO CORRETAMENTE (NOTA: ISSO ACONTECE APENAS SE O GRUPO NÃO TEM LOCAIS PRÉ-DEFINIDOS)
        if (this.presetLocations && this.scaleLocation.name.length > 0 && !validateLocationName(this.scaleLocation.name)) this.setError('local')

        // VERIFICA SE EXISTE QUANTIDADE MÁXIMA DE PLANTÕES POR USUÁRIO, SE SIM, DEVE SER MENOR QUE 10000
        if (scaleMaxShifts > 9999) this.setError('maxShifts')

        //  IS AVAILABLE SHIFT HEXADECIMAL COLOR VALID?
        if (!/^#[A-Fa-f0-9]{6}$/i.test(colorShiftsAvailable)) this.setError('availableShiftsColor')
        // VERIFICA SE A COR DOS PLANTÕES DISPONÍVEIS É BRANCO
        if (isLightColor(colorShiftsAvailable, 80)) this.setError('availableShiftWhite')

        //  IS OWNED SHIFT HEXADECIMAL COLOR VALID?
        if (!/^#[A-Fa-f0-9]{6}$/i.test(colorShiftsOwned)) this.setError('ownedShiftsColor')
        // VERIFICA SE A COR DOS PLANTÕES ASSUMIDOS É BRANCO
        if (isLightColor(colorShiftsOwned, 80)) this.setError('ownedShiftWhite')

        // ARE OWNED AND AVAILABLE SHIFTS COLOR THE SAME?
        if (colorShiftsAvailable === colorShiftsOwned) this.setError('sameShiftsColor')

        const { name, local, maxShifts, availableShiftsColor, ownedShiftsColor, sameShiftsColor, availableShiftWhite, ownedShiftWhite } = this.getErrors()

        if (name || local || maxShifts || availableShiftsColor || ownedShiftsColor || sameShiftsColor || availableShiftWhite || ownedShiftWhite) return false

        //
        // CREATE
        //

        this.loading = true

        const request = await apiCreateScale({
          groupID: this.$route.params.groupID,

          scaleName,
          scaleLocation: this.scaleLocation,
          scaleValue: this.scaleValue,
          scaleMaxShifts,

          startOnMonday: this.startOnMonday,

          availableShiftsColor: colorShiftsAvailable,
          ownedShiftsColor: colorShiftsOwned,
        })

        this.loading = false

        if (request.code === 0) {
          this.showMessage('Atenção!', request.response)
          return false
        }

        //
        // CLOSE DIALOG
        //

        this.close(true)
      },

      //
      // SELECTS EVENTS
      //

      selectedScaleLocation (selectedPlace) {
        const findPlace = this.groupLocations.find(groupPlace => groupPlace.value === selectedPlace)

        // SE O GRUPO NÃO TEM LOCAIS PRÉ-DEFINIDOS, ENTÃO O GESTOR PODE ATRIBUIR UM LOCAL PERSONALIZADO (TEXTO LIVRE)
        // SE O GRUPO TEM LOCAIS PRÉ-DEFINIDOS, ENTÃO O GESTOR SÓ PODE ATRIBUIR UM DESSES LOCAIS

        this.scaleLocation = {
          id: findPlace ? findPlace.value : '',
          name: findPlace ? findPlace.text.split(' <span class="scLocationStatus"')[0] : '',
        }
      },

      onBlurScaleValue (scaleValue) {
        this.scaleValue = scaleValue
      },

      onScaleMaxShiftsChange (inputText) {
        if (!/^\d+$/.test(inputText) || /^0+/.test(inputText)) {
          const newString = inputText.trim().replace(/[^\d]+/g, '').replace(/^0+/, '')
          this.scaleMaxShifts = newString.length > 0 ? newString : '0'
        }
      },

      onChangeCalendarMode () {
        this.startOnMonday = !this.startOnMonday
      },

      //
      // CONFIRM DIALOG OUTPUT/RESPONSE
      //

      cdAction (cdResponse) {
      },
    },
  }

</script>

<style lang="scss" scoped>
  .dialogSubtitle {
    margin: 30px 0 20px 0;
    font-weight: bold;
  }

  .preLocais {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    min-width: 100% !important;
    padding-bottom: 12.5px;
  }

  .locaisMsg {
    color: #777777;
    // font-size: 14px;
    font-weight: 400;
    // color: #495057;
    font-size: 15px;
    // font-weight: 500;
    line-height: 35px;
  }

  .sosShiftColorTag {
    transition-property: filter, box-shadow;
    transition-duration: 100ms;

    cursor: pointer;

    display: inline-block;
    width: 100px;
    height: 25px;
    border-radius: 20px;
    box-shadow: 1px 3px 5px -3px rgba(0, 0, 0, 0.7);

    &:hover {
      filter: brightness(1.2);
      box-shadow: 1px 3px 7px -3px rgba(0, 0, 0, 0.8);
    }
  }

</style>
